<template>
  <div style="overflow: hidden; padding-top: 100px; padding-bottom: 250px" v-if="company">

    <b-row class="m-0 justify-content-center">
      <div style="width: 1700px; max-width: 100%" class="mx-2">
        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 100%" >
          <div class="showcase-header py-4 hover linear-warning text-dark" v-b-toggle.collapse-menu style="position: relative">
            <h4 class="text-center m-0">Speisekarte verwalten</h4>
          </div>
          
          <b-collapse id="collapse-menu" visible class="mt-2">
            
            <div class="pt-3" v-if="menus">
              <p v-if="company.active" class="m-0 text-danger text-center">Um die Speisekarte bearbeiten zu können muss das Restaurant offline geschaltet werden.</p>
              <div v-if="menuCardSorted.length == 0" >
                <p class="m-0 text-center">Es muss zuerst eine Kategorie angelegt werden, bevor Sie fortfahren können.</p>
                <b-row class="m-0 mt-3 justify-content-center">
                  <b-button size="sm" variant="success" @click="newCategoryModal = true"> Neue Kategorie anlegen </b-button>
                </b-row>
                
              </div>
            <draggable v-model="menuCardSorted" @change="log" group="people" @start="drag=false" @end="drag=true" ghost-class="ghost-card" :options="{disabled: disableDragging || company.active}">
              <div v-for="category in menuCardSorted" :key="category._id" >
                <menu-card @disabled="handleDragging" :dropable="drag" :category="category" />
              </div>
            </draggable>
              
            </div>
            <b-row v-else class="m-0 my-3 justify-content-center">
              <div>
                <b-row class="m-0 my-3 justify-content-center">
                  <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
                </b-row>
                <h3 class="text-center">Keine Einträge vorhanden</h3>
              </div>
            </b-row>
             <b-row class="m-0 my-3 justify-content-center">
                <vue-json-to-csv :json-data="menuCSV" :csv-title="company.title + '-Speisekarte'" :labels="{ number: {title: 'Nummer'}, title: { title: 'Name der Speise' }, description: {title: 'Beschreibung'}, category: {title: 'Kategorie'}, price: {title: 'Preis'} }">
                </vue-json-to-csv>
             </b-row>
          </b-collapse>
          
          </div>
        </b-row>

        <b-row class="m-0 mt-4 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 100%" >
            <div class="showcase-header py-4 linear-warning hover text-dark" v-b-toggle.collapse-categories style="position: relative">
              <h4 class="text-center m-0">Kategorien verwalten</h4>
            </div>
            <b-collapse id="collapse-categories" class="pt-2">
              <div class="agenda  p-3" style="border-radius: 10px">
                <b-button size="sm" variant="success" @click="newCategoryModal = true"> Neue Kategorie anlegen </b-button>

                <b-table @row-clicked="openCategoryModal" class="mt-0" :current-page="currentPageCategories" per-page="10" borderless striped responsive v-if="categories" :fields="categoryFields" :items="categories">
        
                    <template v-slot:head()="data">
                      <p class="text-left text-dark" >{{ data.label.toUpperCase() }}</p>
                    </template>

                    <template v-slot:cell(title)="data">
                      <div class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(description)="data">
                      <div class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.description }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(active)="data">
                      <b-form-checkbox
                        class="text-center"
                        style="margin-top: 12px"
                        @change="updateCategories()"
                        switch size="lg"
                        v-model="data.item.active"
                      >
                      {{data.item.active ? 'aktiv' : 'inaktiv'}}
                      </b-form-checkbox>
                    </template>

                    <template v-slot:cell(delete)="data">
                      <b-row class="m-0 mt-1 justify-content-start" v-if="!company.active">
                        <b-button size="sm" :variant="menus.find(menu => menu.category._id == data.item._id) ? 'secondary' : 'danger'" :disabled="Boolean(menus.find(menu => menu.category._id == data.item._id))" class="mt-2 ml-2 mb-2" @click="deleteCategory(data.item._id)">
                          <b-icon v-if="!updating && !menus.find(menu => menu.category._id == data.item._id)" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                          <small v-if="menus.find(menu => menu.category._id == data.item._id)">Speisen vorhanden</small>
                        </b-button>
                      </b-row>
                    </template>
                  
                </b-table>

                <nav>
                  <b-pagination size="sm" :total-rows="categories.length" per-page="10" v-model="currentPageCategories" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
                </nav>

              </div>
            </b-collapse>
          </div>
        </b-row>

        <b-row class="m-0 mt-4 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 100%" >
            <div class="showcase-header py-4 linear-warning hover text-dark" v-b-toggle.collapse-variants style="position: relative">
              <h4 class="text-center m-0">Varianten verwalten</h4>
            </div>
            <b-collapse id="collapse-variants" class="pt-2">
              <div class="agenda  p-3" style="border-radius: 10px">
                <b-button size="sm" class="mb-3" variant="success" @click="newVariantModal = true"> Neue Variante anlegen </b-button>
                
                <b-tabs content-class="p-3">

                  <b-tab title="Varianten" active>
                    <b-table @row-clicked="openVariantModal" class="mt-0" :current-page="currentPageVariants" per-page="10" borderless striped responsive v-if="variants" :fields="variantsFields" :items="variants">
                    
                      <template v-slot:head()="data">
                        <p class="text-left text-dark" >{{ data.label.toUpperCase() }}</p>
                      </template>

                      <template v-slot:cell(title)="data">
                        <div class="mx-2" style="min-width: 250px">
                          <p class="mt-3 text-left text-dark" >{{ data.item.title }}</p>
                        </div>
                      </template>

                      <template v-slot:cell(description)="data">
                        <div class="mx-2" style="min-width: 250px">
                          <p class="mt-3 text-left text-dark" >{{ data.item.description }}</p>
                        </div>
                      </template>

                      <template v-slot:cell(category)="data">
                        <div class="mx-2" style="min-width: 130px">
                          <p v-if="data.item.category" class="mt-3 text-left text-dark" >{{ data.item.category.title }}</p>
                        </div>
                      </template>

                      <template v-slot:cell(price)="data">
                        <div class="mx-2" style="width: 75px">
                          <p class="mt-3 text-left text-dark" >{{ parseFloat(data.item.price).toFixed(2) }}€</p>
                        </div>
                      </template>

                      <template v-slot:cell(extra_price)="data">
                        <div class="mx-2" style="width: 75px">
                          <p class="mt-3 text-left text-dark" v-if="data.item.extra_price !== null" >{{ parseFloat(data.item.extra_price).toFixed(2) }}€</p>
                        </div>
                      </template>

                      <template v-slot:cell(delete)="data">
                        <b-row class="m-0 mt-1 justify-content-center" v-if="!company.active">
                          <b-button size="sm" variant="danger" class="mt-2 ml-2 mb-2" @click="deleteVariant(data.item._id)">
                            <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                          </b-button>
                        </b-row>
                      </template>
                  
                    </b-table>

                    <nav>
                      <b-pagination size="sm" :total-rows="variants.length" per-page="10" v-model="currentPageVariants" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
                    </nav>
                  </b-tab>

                  <b-tab title="Vorlagen" v-if="variants.length > 0">
                    <b-table @row-clicked="openVariantTemplateModal" class="mt-0" :current-page="currentPageVariantsTemplates" per-page="10" borderless striped responsive v-if="variantsTemplates" :fields="variantsTemplatesFields" :items="variantsTemplates">
        
                    <template v-slot:head()="data">
                      <p class="m-0 p-0 text-left text-dark" >{{ data.label.toUpperCase() }}</p>
                    </template>

                    <template v-slot:cell(title)="data">
                      <div  class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(category)="data">
                      <div class="mx-2" style="min-width: 130px">
                        <p v-if="data.item.category" class="mt-3 text-left text-dark" >{{ data.item.category.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(description)="data" >
                      <div class="mx-2" style="min-width: 400px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.description }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(active)="data">
                      <b-form-checkbox
                        class="text-center ml-2"
                        style="margin-top: 12px"
                        @change="updateVariantsTemplate()"
                        switch size="lg"
                        v-model="data.item.active"
                      >
                      </b-form-checkbox>
                    </template>

                    <template v-slot:cell(delete)="data">
                      <b-row class="m-0 mt-1 justify-content-center" v-if="!company.active">
                        <b-button size="sm" variant="danger" class="mt-2 ml-2 mb-2" @click="deleteVariantsTemplate(data.item._id)">
                          <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                        </b-button>
                      </b-row>
                    </template>
                  
                  </b-table>
                  <nav>
                    <b-pagination size="sm" :total-rows="variantsTemplates.length" per-page="10" v-model="currentPageVariantsTemplates" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
                  </nav>
                  </b-tab>

                </b-tabs>
              

                <h4 class="my-4" v-if="variants.length > 0">Vorlage erstellen</h4>

                <b-form @submit.prevent="postVariantsTemplate" v-if="variants.length > 0">

                    <b-form-group
                      class="mx-1"
                      label="Name der Vorlage:"
                      description="z.B.: Pizzagröße, Fleischsorte, ..."
                    >
                      <b-form-input
                        :state="Boolean(newVariantTemplate.title)"
                        v-model="newVariantTemplate.title"
                        type="text"
                        required
                        placeholder="Name eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Beschreibung der Vorlage:"
                    >
                      <b-form-input
                        v-model="newVariantTemplate.description"
                        type="text"
                        placeholder="Beschreibung eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Kategorie:"
                      description="Die Kategorie dient zur Zuordnung der Vorlage. Es werden nur Extras angezeigt, die den jeweiligen Kategorien zugeordnet sind."
                    >
                      <b-form-select v-model="newVariantTemplate.category" :options="categoriesOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mx-1"
                      label="Extras:"
                    >
                    <b-form-checkbox-group
                        class="my-3"
                        :disabled="!newVariantTemplate.category._id && !newVariantTemplate.category.empty && false"
                        v-model="newVariantTemplate.variants"
                        :options="variantsOptions.filter(extra => extra.data.category ? extra.data.category._id == newVariantTemplate.category._id : true)"
                        name="extras"
                      ></b-form-checkbox-group>
                    </b-form-group>

                  <b-button :disabled="newVariantTemplate.variants.length == 0" class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
                </b-form>
               
              </div>
            </b-collapse>
          </div>
        </b-row>

        <b-row class="m-0 mt-4 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 100%" >
            <div class="showcase-header py-4 linear-warning text-dark" v-b-toggle.collapse-extras style="position: relative">
              <h4 class="text-center m-0">Beilagen / Extras verwalten</h4>
            </div>
            <b-collapse id="collapse-extras" class="pt-2">
              <div class="agenda  p-3" style="border-radius: 10px">
                
              <b-button size="sm" class="mb-3" variant="success" @click="newExtraModal = true"> Neue Beilage / Extra anlegen </b-button>

              <b-tabs content-class="p-3">

                <b-tab title="Extras / Beilagen" active>
                  <b-table @row-clicked="openExtraModal" class="mt-0" :current-page="currentPageExtras" per-page="10" borderless striped responsive v-if="extras" :fields="extrasFields" :items="extras">
        
                    <template v-slot:head()="data">
                      <p class="m-0 p-0 text-left text-dark" >{{ data.label.toUpperCase() }}</p>
                    </template>

                    <template v-slot:cell(title)="data">
                      <div  class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(description)="data">
                      <div class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.description }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(category)="data">
                      <div class="mx-2" style="min-width: 130px">
                        <p v-if="data.item.category" class="mt-3 text-left text-dark" >{{ data.item.category.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(price)="data">
                      <div  class="mx-2" style="width: 75px">
                        <p class="mt-3 text-left text-dark" >{{ parseFloat(data.item.price).toFixed(2) }}€</p>
                      </div>
                    </template>

                    <template v-slot:cell(active)="data">
                      <b-form-checkbox
                        class="text-center ml-2"
                        style="margin-top: 12px"
                        @change="updateExtras()"
                        switch size="lg"
                        v-model="data.item.active"
                      >
                      </b-form-checkbox>
                    </template>

                    <template v-slot:cell(delete)="data">
                      <b-row class="m-0 mt-1 justify-content-center" v-if="!company.active">
                        <b-button size="sm" variant="danger" class="mt-2 ml-2 mb-2" @click="deleteExtra(data.item._id)">
                          <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                        </b-button>
                      </b-row>
                    </template>
                  
                  </b-table>
                  <nav>
                    <b-pagination size="sm" :total-rows="extras.length" per-page="10" v-model="currentPageExtras" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
                  </nav>
                </b-tab>

                <b-tab title="Vorlagen" v-if="extras.length > 0">
                  <b-table @row-clicked="openExtraTemplateModal" class="mt-0" :current-page="currentPageExtrasTemplates" per-page="10" borderless striped responsive v-if="extrasTemplates" :fields="extrasTemplatesFields" :items="extrasTemplates">
        
                    <template v-slot:head()="data">
                      <p class="m-0 p-0 text-left text-dark" >{{ data.label.toUpperCase() }}</p>
                    </template>

                    <template v-slot:cell(title)="data">
                      <div  class="mx-2" style="min-width: 250px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(category)="data">
                      <div class="mx-2" style="min-width: 130px">
                        <p v-if="data.item.category" class="mt-3 text-left text-dark" >{{ data.item.category.title }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(description)="data" >
                      <div class="mx-2" style="min-width: 400px">
                        <p class="mt-3 text-left text-dark" >{{ data.item.description }}</p>
                      </div>
                    </template>

                    <template v-slot:cell(delete)="data">
                      <b-row class="m-0 mt-1 justify-content-center" v-if="!company.active">
                        <b-button size="sm" variant="danger" class="mt-2 ml-2 mb-2" @click="deleteExtrasTemplate(data.item._id)">
                          <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                        </b-button>
                      </b-row>
                    </template>
                  
                  </b-table>
                  <nav>
                    <b-pagination size="sm" :total-rows="extrasTemplates.length" per-page="10" v-model="currentPageExtrasTemplates" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
                  </nav>
                </b-tab>
              </b-tabs>
              
            
                <h4 class="my-4" v-if="extras.length > 0">Vorlage erstellen</h4>

                <b-form @submit.prevent="postExtraTemplate" v-if="extras.length > 0">

                    <b-form-group
                      class="mx-1"
                      label="Name der Vorlage:"
                      description="z.B.: Pizzabeläge, Beilagen für Burger, ..."
                    >
                      <b-form-input
                        v-model="newExtraTemplate.title"
                        :state="Boolean(newExtraTemplate.title)"
                        type="text"
                        required
                        placeholder="Name eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Beschreibung der Vorlage:"
                    >
                      <b-form-input
                        v-model="newExtraTemplate.description"
                        type="text"
                        placeholder="Beschreibung eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Kategorie:"
                      description="Die Kategorie dient zur Zuordnung der Vorlage. Es werdem nur Varianten angezeigt, die den jeweiligen Kategorien zugeordnet sind."
                    >
                      <b-form-select v-model="newExtraTemplate.category" :options="categoriesOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mx-1"
                      label="Extras:"
                    >
                    <b-form-checkbox-group
                        class="my-3"
                        :disabled="!newExtraTemplate.category._id && !newExtraTemplate.category.empty && false"
                        v-model="newExtraTemplate.extras"
                        :options="extrasOptions.filter(extra => extra.data.category ? extra.data.category._id == newExtraTemplate.category._id : true)"
                        name="extras"
                      ></b-form-checkbox-group>
                    </b-form-group>

                  <b-button :disabled="newExtraTemplate.extras.length == 0" class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
                </b-form>

              </div>
            </b-collapse>
          </div>
        </b-row>

        <b-row class="m-0 mt-4 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 100%" >
            <div class="showcase-header py-4 linear-warning hover text-dark" v-b-toggle.collapse-import style="position: relative">
              <h4 class="text-center m-0">Speisekarte importieren</h4>
            </div>
            <b-collapse id="collapse-import" class="pt-2">
              <div class="agenda  p-3" style="border-radius: 10px">
                  <vue-csv-import
                  :headers="true"
                    v-model="parseCsv"
                    :map-fields="['Nummer', 'Name', 'Beschreibung', 'Kategorie', 'Preis']">

                    <template slot="error">
                        Dateityp wird nicht unterstützt!
                    </template>

                    <template slot="thead">
                        <tr>
                            <th>Benötigte Felder</th>
                            <th>Vorhandene Felder</th>
                        </tr>
                    </template>

                    <template slot="next" slot-scope="{load}">
                        <b-button @click.prevent="load">Datei laden</b-button>
                    </template>

                    <template slot="submit" slot-scope="{submit}">
                        <b-button @click.prevent="submit">Import starten</b-button>
                    </template>
                </vue-csv-import>    
              </div>
            </b-collapse>
          </div>
        </b-row>
      </div>
    </b-row>

    

    <!-- Edit MenuItem Modal -->
    <b-modal v-model="menuItemModal" size="xl" hide-footer hide-header v-if="menuItemBuffer">
      <div class="pt-2 rounded bg-white">
        <b-tabs content-class="p-3 mt-1">

          <b-tab title="Speiseinfos" active>
            <div>
              <b-form @submit.prevent="updateMenuItem(menuItemBuffer)">
                  <b-form-group
                    class="mx-1"
                    label="Sortierung:"
                    description="Mit dieser Zahl kann die Anordnung der Speisen innerhalb der Kategorie bestimmt werden (1 als erstes, 2 als nächstes, ...)"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.sort_number"
                      type="number"
                      step="1"
                      placeholder="Nummer eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Nummer:"
                    description="Nummer des Eintrages für eine leichtere Zuordnung der Bestellung und ist optional"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.number"
                      type="text"
                      placeholder="Nummer eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Name der Speise:"
                    description="Dieser Eintrag wird hervorgehoben dargestellt"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.title"
                      type="text"
                      required
                      placeholder="Titel eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung:"
                    description="Dieser Eintrag wird ergänzend dargestellt (optional)"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.description"
                      type="text"
                      placeholder="Beschreibung eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Kategorie:"
                  >
                    <b-form-select required v-model="menuItemBuffer.category" :options="categoriesOptions"></b-form-select>
                  </b-form-group>
                  
                  <b-form-group
                    class="mx-1"
                    label="Preis in €:"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Preis eingeben"
                    ></b-form-input>
                  </b-form-group>
                
              </b-form>
            </div>
          </b-tab>

          <b-tab title="Varianten">
            <div class="mb-3 bg-light p-1 rounded" v-for="(variant, index) in menuItemBuffer.variants" :key="variant.index">
              <h5 class="ml-1">{{variant.title}}</h5>

              <div class="ml-2" v-for="vari in variant.variants" :key="vari.index">
                {{ variants.find(el => el._id == vari) ? variants.find(el => el._id == vari).title + ' (+ ' + variants.find(el => el._id == vari).price.toFixed(2) + '€)' : null }}
              </div>

              <b-button size="sm" variant="danger" class="mt-2 ml-1 mb-2" @click="menuItemBuffer.variants.splice(index, 1), updateMenuItem(menuItemBuffer)" v-if="editModeMenu">
                <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
              </b-button>

              </div>
              <div class="mt-3" v-if="editModeMenu">
                <b-form-group
                    v-if="variantsTemplates.length > 0"
                    class="mx-1"
                    label="Vorlage einfügen:"
                  >
                  <b-form-select :disabled="!editModeMenu" @change="copyVariantsTemplate" v-model="copyVariants" :options="variantsTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == menuItemBuffer.category._id : true)"></b-form-select>
                </b-form-group>
                <b-card>
                <h5 class="ml-1">Neue Variantenauswahl hinzufügen:</h5>
                
                <b-form @submit.prevent="addVariant(menuItemBuffer)">
                <b-form-group
                  class="mx-1"
                  label="Name der Variante:"
                  description="z.B.: Fleischsorte, Größe, Soße, Beilage "
                >
                  <b-form-input
                    style="width: 400px"
                    v-model="newMenuVariant.title"
                    type="text"
                    required
                    size="sm"
                    placeholder="Name eingeben"
                  ></b-form-input>
                </b-form-group>
                <b-form-checkbox-group
                  size="sm"
                  class="mx-1 mb-4"
                  v-model="newMenuVariant.variants"
                  :options="variantsOptions.filter(variant => variant.data.category ? variant.data.category._id == menuItemBuffer.category._id : true)"
                  name="variants"
                ></b-form-checkbox-group>
                
              <b-button class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
            </b-form>
            </b-card>
          </div>
          </b-tab>

          <b-tab title="Extras">
            <b-form-group
              v-if="extrasTemplates.length > 0"
                class="mx-1"
                label="Vorlage verwenden:"
              >
              <b-form-select :disabled="!editModeMenu" @change="copyExtrasTemplate" v-model="copyExtras" :options="extrasTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == menuItemBuffer.category._id : true)"></b-form-select>
            </b-form-group>
            <b-card>
              <p class="m-0" v-if="menuItemBuffer.extraTemplate">Aktive Vorlage: {{ menuItemBuffer.extraTemplate.title }}</p>
              <b-form-checkbox-group
                class="my-3"
                :disabled="!editModeMenu || Boolean(menuItemBuffer.extraTemplate)"
                v-model="menuItemBuffer.extras"
                :options="extrasOptions.filter(extra => extra.data.category ? extra.data.category._id == menuItemBuffer.category._id : true)"
                name="allergens"
              ></b-form-checkbox-group>
              <div v-if="menuItemBuffer.extraTemplate && editModeMenu">
                <b-button class="my-2" size="sm" @click="removeExtraTemplate(menuItemBuffer)"> Extras individualisieren </b-button>
                <div>
                  <small class="text-secondary">(individuelle Extras werden nicht mehr über die Vorlage aktualisiert)</small>
                </div>
              </div>
              
              
            </b-card>
            
          </b-tab>

          <b-tab title="Zusatzstoffe">
            <b-form-checkbox-group
              class="my-3"
              :disabled="!editModeMenu"
              v-model="menuItemBuffer.additives"
              :options="additivesOptions"
              stacked
              name="additives"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Allergene">
            <b-form-checkbox-group
              :disabled="!editModeMenu"
              class="my-3"
              v-model="menuItemBuffer.allergens"
              :options="allergensOptions"
              stacked
              name="allergens"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Produktbild">
            <b-card>
              
              <div class="image-preview text-left py-3" v-if="!imageData && menuItemBuffer.img">
                <img class="preview rounded shadow" alt="new" style="max-width: 50%" :src="getImage(menuItemBuffer.img.image)">
              </div>

              <div v-if="!imageData && !menuItemBuffer.img">
                <h5 class="text-center">Kein Bild ausgewählt</h5>
              </div>

              <div v-if="editModeMenu">
                <div class="image-preview text-left py-3" v-if="imageData.length > 0">
                  <img class="preview rounded shadow" alt="new" style="max-width: 50%" :src="imageData">
                </div>

                <b-row class="m-0">
                  <b-button @click="uploadsModal = true">Bild aus Mediathek wählen</b-button>
                  <b-button v-if="menuItemBuffer.img" class="ml-2" variant="danger" @click="menuItemBuffer.img = null">Bild entfernen</b-button>
                </b-row>

                

                <b-form-group
                  class="mt-3"
                  label="Neues Produktbild hochladen:"
                  description="Das Bild wird in den Produktinformationen angezeigt"
                >
                  <b-form-file
                    @change="previewImage" accept="image/*"
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Wähle eine Datei aus..."
                    drop-placeholder="Hier her ziehen..."
                  ></b-form-file>
                </b-form-group>
                <div class="my-3">Ausgewählte Datei: {{ file ? file.name : '' }}</div>
                <b-button v-if="!uploadComplete" :disabled="!file" class="" variant="primary" @click="uploadImage">{{ file ? 'hochladen' : 'kein Bild ausgewählt'}}  <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
                <b-button v-else disabled class="" variant="primary"> Foto hochgeladen! <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
              </div>
              
            </b-card>
          </b-tab>

        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button :disabled="!editModeMenu" class="" variant="primary" @click="updateMenuItem(menuItemBuffer)">{{ editModeMenu ? 'aktualisieren' : 'bearbeitung deaktiviert'}}  <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="menuItemModal = false">schließen</b-button>
        </b-row>
      </div>
    </b-modal>

    <!-- New MenuItem Modal -->
    <b-modal v-model="newMenuModal" size="xl" hide-footer hide-header>
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Speise hinzufügen !!!!!</h4>
          <font-awesome-icon @click="newMenuModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
          <div class="p-3" style="border-radius: 10px" >
          <b-form @submit.prevent="postMenu">
            <b-card>
              <b-form-group
                class="mx-1"
                label="Kopieren von bestehender Speise:"
              >
                <b-form-select @change="copyMenuItem()" v-model="copyMenu" :options="menuItemsOptions"></b-form-select>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Name der Speise:"
                description="Dieser Eintrag wird hervorgehoben dargestellt"
              >
                <b-form-input
                  v-model="newMenu.title"
                  type="text"
                  required
                  placeholder="Titel eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Beschreibung:"
                description="Dieser Eintrag wird ergänzend dargestellt (optional)"
              >
                <b-form-input
                  v-model="newMenu.description"
                  type="text"
                  placeholder="Beschreibung eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Kategorie:"
              >
                <b-form-select v-model="newMenu.category" :options="categoriesOptions"></b-form-select>
              </b-form-group>
                

              <b-form-group
                class="mx-1"
                label="Nummer:"
                description="Nummer des Eintrages für eine leichtere Zuordnung der Bestellung"
              >
                <b-form-input
                  v-model="newMenu.number"
                  type="text"
                  placeholder="Nummer eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Preis in €:"
              >
                <b-form-input
                  v-model="newMenu.price"
                  type="number"
                  step="0.01"
                  required
                  placeholder="Preis eingeben"
                ></b-form-input>
              </b-form-group>
              </b-card>
              <br>
              <b-card>
                <p>Beilagen</p>
                <div v-if="newMenu.category">
                <b-form-group
                  v-if="extrasTemplates.length > 0 && newMenu.category"
                    class="mx-1"
                    label="Vorlage verwenden:"
                  >
                  <b-form-select @change="copyExtrasTemplate" v-model="copyExtras" :options="extrasTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == newMenu.category._id : true)"></b-form-select>
                </b-form-group>

                <b-card>
                  <p class="m-0" v-if="newMenu.extraTemplate">Aktive Vorlage: {{ newMenu.extraTemplate.title }}</p>
                  <b-form-checkbox-group
                    class="my-3"
                    :disabled="Boolean(newMenu.extraTemplate)"
                    v-model="newMenu.extras"
                    :options="extrasOptions.filter(extra => extra.data.category ? extra.data.category._id == newMenu.category._id : true)"
                    name="allergens"
                  ></b-form-checkbox-group>
                  <div v-if="newMenu.extraTemplate">
                    <b-button class="my-2" size="sm" @click="removeExtraTemplate(newMenu)"> Extras individualisieren </b-button>
                    <div>
                      <small class="text-secondary">(individuelle Extras werden nicht mehr über die Vorlage aktualisiert)</small>
                    </div>
                  </div>
                  
                </b-card>
                </div>
                <p v-else class="text-danger">Kategorie wählen!</p>

             
              </b-card>
              <br>
              <b-card>
                <p>Varianten<p>

                <div v-if="newMenu.category">
                  <div class="mb-3 bg-light p-1 rounded" v-for="(variant, index) in newMenu.variants" :key="variant.index">
                    <h5 class="ml-1">{{variant.title}}</h5>

                    <div class="ml-2" v-for="vari in variant.variants" :key="vari.index">
                      {{ variants.find(el => el._id == vari) ? variants.find(el => el._id == vari).title + ' (+ ' + variants.find(el => el._id == vari).price.toFixed(2) + '€)' : null }}
                    </div>

                    <b-button size="sm" variant="danger" class="mt-2 ml-1 mb-2" @click="newMenu.variants.splice(index, 1)" >
                      <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                    </b-button>

                  </div>

                  <div class="mt-3" v-if="newMenu.category">
                      <b-form-group
                        v-if="extrasTemplates.length > 0 && newMenu.category"
                          class="mx-1"
                          label="Vorlage einfügen:"
                        >
                        <b-form-select @change="copyVariantsTemplate" v-model="copyVariants" :options="variantsTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == newMenu.category._id : true)"></b-form-select>
                      </b-form-group>
                      <b-card>
                      <h5 class="ml-1">Neue Variantenauswahl hinzufügen:</h5>
                      
                      <b-form @submit.prevent="addVariant(newMenu)">
                      <b-form-group
                        class="mx-1"
                        label="Name der Variante:"
                        description="z.B.: Fleischsorte, Größe, Soße, Beilage "
                      >
                        <b-form-input
                          style="width: 400px"
                          v-model="newMenuVariant.title"
                          type="text"
                          required
                          size="sm"
                          placeholder="Name eingeben"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-checkbox-group
                        size="sm"
                        class="mx-1 mb-4"
                        v-model="newMenuVariant.variants"
                        :options="variantsOptions.filter(variant => variant.data.category ? variant.data.category._id == newMenu.category._id : true)"
                        name="variants"
                      ></b-form-checkbox-group>
                      
                    <b-button class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
                  </b-form>
                  </b-card>
                  </div>
                </div>
                
                <p v-else class="text-danger">Kategorie wählen!</p>
             
              </b-card>
              <br>
              <b-card>
                <b-button v-b-toggle.collapse-allergens-menu variant="primary">Allergene anzeigen</b-button>
                <b-collapse id="collapse-allergens-menu" class="mt-2">
                    <b-form-group
                      label="Allergene"
                    >
                      <b-form-checkbox-group
                        v-model="newMenu.allergens"
                        :options="allergensOptions"
                        name="allergens"
                        stacked
                      ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
              </b-card>
              <br>
              <b-card>
                <b-button v-b-toggle.collapse-additives-menu variant="primary">Zusatzstoffe anzeigen</b-button>
                <b-collapse id="collapse-additives-menu" class="mt-2">
                  <b-form-group
                  label="Zusatzstoffe"
                  >
                    <b-form-checkbox-group
                      v-model="newMenu.additives"
                      :options="additivesOptions"
                      name="additives"
                      stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
              </b-card>
              <br>
            <b-row class="m-0 mx-1 justify-content-between">
              <b-button variant="success" type="submit">hinzufügen</b-button>
              <b-button @click="newMenuModal = false">schließen</b-button>
            </b-row>
            
          </b-form>
        </div>
      </div>
    </b-modal>

    <!-- Edit Category Modal -->
    <b-modal v-model="categoryModal" size="xl" hide-footer hide-header v-if="categoryBuffer">
      <div class=" rounded bg-white">        
        <b-tabs content-class="p-3 mt-1" fill>
          <b-tab title="Kategorieinfos" active>
            <div>
              <b-form @submit.prevent="updateCategory(categoryBuffer)">

                  <b-form-group
                    class="mx-1"
                    label="Name der Kategorie:"
                  >
                    <b-form-input
                      v-model="categoryBuffer.title"
                      type="text"
                      required
                      placeholder="Name eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung:"
                  >
                    <b-form-input
                      v-model="categoryBuffer.description"
                      type="text"
                      step="0.01"
                      required
                      placeholder="Beschreibung eingeben"
                    ></b-form-input>
                  </b-form-group>
                
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button variant="primary" @click="updateCategory(categoryBuffer)">aktualisieren<b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="categoryModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <!-- New Category Modal -->
    <b-modal v-model="newCategoryModal" size="xl" hide-footer hide-header>
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Kategorie hinzufügen</h4>
          <font-awesome-icon @click="newCategoryModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
          <div class="p-3" style="border-radius: 10px">
            <b-form @submit.prevent="postCategory">
              <b-card class="my-2">

                <b-form-group
                  class="mx-1"
                  label="Name der Kategorie:"
                >
                  <b-form-input
                    v-model="newCategory.title"
                    type="text"
                    required
                    placeholder="Name eingeben"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mx-1"
                  label="Beschreibung:"
                >
                  <b-form-input
                    v-model="newCategory.description"
                    type="text"
                    placeholder="Beschreibung eingeben (optional)"
                  ></b-form-input>
                </b-form-group>

              </b-card>

            <b-row class="m-0 mx-1 justify-content-between">
              <b-button variant="success" type="submit">hinzufügen</b-button>
              <b-button @click="newCategoryModal = false">schließen</b-button>
            </b-row>
          </b-form>
        </div>
      </div>
    </b-modal>

    <!-- Edit Variant Modal -->
    <b-modal v-model="variantModal" size="xl" hide-footer hide-header v-if="variantBuffer">
      <div class="pt-2 rounded bg-white">
        
        <b-tabs content-class="p-3" fill>
          <b-tab title="Varianteninfos" active>
            <div>
              <b-form @submit.prevent="updateVariant(variantBuffer)">

                  <b-form-group
                    class="mx-1"
                    label="Name der Variante:"
                  >
                    <b-form-input
                      :state="Boolean(variantBuffer.title)"
                      v-model="variantBuffer.title"
                      type="text"
                      required
                      placeholder="Name eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung der Variante:"
                  >
                    <b-form-input
                      v-model="variantBuffer.description"
                      type="text"
                      placeholder="Beschreibung eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Aufpreis:"
                  >
                    <b-form-input
                      :state="Boolean(variantBuffer.price || variantBuffer.price == 0)"
                      v-model="variantBuffer.price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Aufpreis eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Aufpreis für Extras / Beilagen:"
                  >
                    <b-form-input
                      :state="Boolean(variantBuffer.extra_price || variantBuffer.extra_price == 0)"
                      v-model="variantBuffer.extra_price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Aufpreis eingeben"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mx-1"
                    label="Kategorie:"
                    description="Wird eine Kategorie ausgewählt, so ist die Variante nur in jener Kategorie verfügbar"
                  >
                    <b-form-select  v-model="variantBuffer.category" :options="categoriesOptions"></b-form-select>
                  </b-form-group>
                
              </b-form>
            </div>
          </b-tab>

          <b-tab title="Zusatzstoffe">
            <b-form-checkbox-group
              class="my-3"
              v-model="variantBuffer.additives"
              :options="additivesOptions"
              stacked
              name="additives"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Allergene">
            <b-form-checkbox-group
              class="my-3"
              v-model="variantBuffer.allergens"
              :options="allergensOptions"
              stacked
              name="allergens"
            ></b-form-checkbox-group>
          </b-tab>

        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button class="" variant="primary" @click="updateVariant(variantBuffer)">aktualisieren  <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="variantModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <!-- New Variant Modal -->
    <b-modal v-model="newVariantModal" size="xl" hide-footer hide-header>
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Variante hinzufügen</h4>
          <font-awesome-icon @click="newVariantModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
          <div class="p-3" style="border-radius: 10px">
            <b-form @submit.prevent="postCategory">
              <b-form @submit.prevent="postVariant">
                  <b-card class="my-2">
                  <b-form-group
                    class="mx-1"
                    label="Name der Variante:"
                  >
                    <b-form-input
                      :state="Boolean(newVariant.title)"
                      v-model="newVariant.title"
                      type="text"
                      required
                      placeholder="Name eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung der Variante:"
                  >
                    <b-form-input
                      v-model="newVariant.description"
                      type="text"
                      placeholder="Beschreibung eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Aufpreis:"
                  >
                    <b-form-input
                      v-model="newVariant.price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Aufpreis eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Aufpreis für Extras / Beilagen:"
                  >
                    <b-form-input
                      v-model="newVariant.extra_price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Aufpreis eingeben"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="mx-1"
                    label="Kategorie:"
                    description="Wird eine Kategorie ausgewählt, so ist die Variante nur in jener Kategorie verfügbar"
                  >
                    <b-form-select v-model="newVariant.category" :options="categoriesOptions"></b-form-select>
                  </b-form-group>
                  </b-card>
                  
                  <b-card class="my-2">
                    <b-button v-b-toggle.collapse-additives variant="primary">Zusatzstoffe anzeigen</b-button>
                    <b-collapse id="collapse-additives" class="mt-2">
                      <b-form-group
                      label="Zusatzstoffe"
                    >
                      <b-form-checkbox-group
                        class=""
                        stacked
                        v-model="newVariant.additives"
                        :options="additivesOptions"
                        name="additives"
                      ></b-form-checkbox-group>
                    </b-form-group>
                    </b-collapse>
                  </b-card>

                  <b-card class="my-2">
                    <b-button v-b-toggle.collapse-allergens variant="primary">Allergene anzeigen</b-button>
                    <b-collapse id="collapse-allergens" class="mt-2">
                     <b-form-group
                      label="Allergene"
                      >
                        <b-form-checkbox-group
                          stacked
                          v-model="newVariant.allergens"
                          :options="allergensOptions"
                          name="allergens"
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </b-collapse>
                  </b-card>

                <b-row class="m-0 mx-1 justify-content-between">
                  <b-button variant="success" type="submit">hinzufügen</b-button>
                  <b-button @click="newVariantModal = false">schließen</b-button>
                </b-row>
              </b-form>
          </b-form>
        </div>
      </div>
    </b-modal>

    <!-- Edit Extra Modal -->
    <b-modal v-model="extraModal" size="xl" hide-footer hide-header v-if="extraBuffer">
      <div class="pt-2 rounded bg-white">
        
        <b-tabs content-class="p-3 mt-1" fill>
          <b-tab title="Extrainfos" active>
            <div>
              <b-form @submit.prevent="updateExtra(extraBuffer)">

                  <b-form-group
                    class="mx-1"
                    label="Name der Beilage / Extra:"
                  >
                    <b-form-input
                      :state="Boolean(extraBuffer.title)"
                      v-model="extraBuffer.title"
                      type="text"
                      required
                      placeholder="Name eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung der Beilage / Extra:"
                  >
                    <b-form-input
                      v-model="extraBuffer.description"
                      type="text"
                      required
                      placeholder="Beschreibung eingeben"
                    ></b-form-input>
                  </b-form-group>
                  
                  <b-form-group
                    class="mx-1"
                    label="Preis in €:"
                  >
                    <b-form-input
                      v-model="extraBuffer.price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Preis eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Kategorie:"
                  >
                    <b-form-select v-model="extraBuffer.category" :options="categoriesOptions"></b-form-select>
                  </b-form-group>
                
              </b-form>
            </div>
          </b-tab>

          <b-tab title="Zusatzstoffe">
            <b-form-checkbox-group
              class="my-3"
              v-model="extraBuffer.additives"
              :options="additivesOptions"
              stacked
              name="additives"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Allergene">
            <b-form-checkbox-group
              class="my-3"
              v-model="extraBuffer.allergens"
              :options="allergensOptions"
              stacked
              name="allergens"
            ></b-form-checkbox-group>
          </b-tab>

        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button variant="primary" @click="updateExtra(extraBuffer)">aktualisieren <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="extraModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <!-- New Extra Modal -->
    <b-modal v-model="newExtraModal" size="xl" hide-footer hide-header>
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Beilage / Extra hinzufügen</h4>
          <font-awesome-icon @click="newExtraModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
          <div class="p-3" style="border-radius: 10px">
            <b-form @submit.prevent="postExtra">
              <b-card class="my-2">
              <b-form-group
                class="mx-1"
                label="Name der Beilage / Extra:"
              >
                <b-form-input
                  v-model="newExtra.title"
                  :state="Boolean(newExtra.title)"
                  type="text"
                  required
                  placeholder="Name eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Beschreibung der Beilage / Extra:"
              >
                <b-form-input
                  v-model="newExtra.description"
                  type="text"
                  placeholder="Beschreibung eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Preis:"
              >
                <b-form-input
                  v-model="newExtra.price"
                  type="number"
                  step="0.01"
                  required
                  placeholder="Preis eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Kategorie:"
                description="Wird eine Kategorie ausgewählt, so ist die Beilage / das Extra nur in jener Kategorie verfügbar"
              >
                <b-form-select v-model="newExtra.category" :options="categoriesOptions"></b-form-select>
              </b-form-group>
              </b-card>
              <b-card class="my-2">
                <b-button v-b-toggle.collapse-additives variant="primary">Zusatzstoffe anzeigen</b-button>
                <b-collapse id="collapse-additives" class="mt-2">
                  <b-form-group
                    label="Zusatzstoffe"
                  >
                    <b-form-checkbox-group
                      class=""
                      v-model="newExtra.additives"
                      :options="additivesOptions"
                      stacked
                      name="additives"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
              
              </b-card>
              <b-card class="my-2">
                <b-button v-b-toggle.collapse-allergens variant="primary">Allergene anzeigen</b-button>
                <b-collapse id="collapse-allergens" class="mt-2">
                  <b-form-group
                    label="Allergene"
                  >
                    <b-form-checkbox-group
                      v-model="newExtra.allergens"
                      :options="allergensOptions"
                      stacked
                      name="allergens"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
                
              </b-card>

            <b-row class="m-0 mx-1 justify-content-between">
              <b-button variant="success" type="submit">hinzufügen</b-button>
              <b-button @click="newExtraModal = false">schließen</b-button>
            </b-row>
          </b-form>
        </div>
      </div>
    </b-modal>

    <!-- Edit ExtrasTemplate Modal -->
    <b-modal v-model="extrasTemplateModal" size="xl" hide-footer hide-header v-if="extrasTemplateBuffer">
      <div class=" rounded bg-white">        
        <b-tabs content-class="p-3 mt-1" fill>
          <b-tab title="Extra Vorlage" active>
            <div>
              <b-form @submit.prevent="updateExtrasTemplate(extrasTemplateBuffer)">

                  <b-form-group
                      class="mx-1"
                      label="Name der Vorlage:"
                    >
                      <b-form-input
                        v-model="extrasTemplateBuffer.title"
                        type="text"
                        required
                        placeholder="Name eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Beschreibung der Vorlage:"
                    >
                      <b-form-input
                        v-model="extrasTemplateBuffer.description"
                        type="text"
                        required
                        placeholder="Beschreibung eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Kategorie:"
                      description="Die Kategorie dient zur Zuordnung der Vorlage und ist optional."
                    >
                      <b-form-select v-model="extrasTemplateBuffer.category" :options="categoriesOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mx-1"
                      label="Extras:"
                    >
                    <b-form-checkbox-group
                        class="my-3"
                        v-model="extrasTemplateBuffer.extras"
                        :options="extrasOptions"
                        name="extras"
                      ></b-form-checkbox-group>
                    </b-form-group>
                
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button variant="primary" @click="updateExtrasTemplate(extrasTemplateBuffer)">aktualisieren <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="extrasTemplateModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <!-- Edit VariantsTemplate Modal -->
    <b-modal v-model="variantsTemplateModal" size="xl" hide-footer hide-header v-if="variantsTemplateBuffer">
      <div class=" rounded bg-white">
        <b-tabs content-class="p-3 mt-1" fill>
          <b-tab title="Varianten Vorlage" active>
            <div>
              <b-form @submit.prevent="updateExtrasTemplate(extrasTemplateBuffer)">

                  <b-form-group
                      class="mx-1"
                      label="Name der Vorlage:"
                    >
                      <b-form-input
                        v-model="variantsTemplateBuffer.title"
                        type="text"
                        required
                        placeholder="Name eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Beschreibung der Vorlage:"
                    >
                      <b-form-input
                        v-model="variantsTemplateBuffer.description"
                        type="text"
                        required
                        placeholder="Beschreibung eingeben"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mx-1"
                      label="Kategorie:"
                      description="Die Kategorie dient zur Zuordnung der Vorlage."
                    >
                      <b-form-select required v-model="variantsTemplateBuffer.category" :options="categoriesOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mx-1"
                      label="Extras:"
                    >
                    <b-form-checkbox-group
                        class="my-3"
                        v-model="variantsTemplateBuffer.variants"
                        :options="variantsOptions.filter(extra => extra.data.category ? extra.data.category._id == variantsTemplateBuffer.category ? variantsTemplateBuffer.category._id : null : true)"
                        name="extras"
                      ></b-form-checkbox-group>
                    </b-form-group>
                
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button variant="primary" @click="updateVariantsTemplate(variantsTemplateBuffer)">aktualisieren <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="variantsTemplateModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <b-modal v-model="uploadsModal" hide-footer hide-header size="xl" v-if="media && userInformations">
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Medienauswahl</h4>
          <font-awesome-icon @click="uploadsModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 justify-content-center">
          <img
            :key="img.index"
            v-for="img in media"
            class="m-2 hover preview rounded shadow"
            style="width: 40%; height: 40%"        
            :src="getImage('uploads/'+ userInformations._id +'/uploads/' + img)"
            alt="image slot"
            @click="setMediaImage('uploads/'+ userInformations._id +'/uploads/' + img)"
          >
        </b-row>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button @click="uploadsModal = false">schließen</b-button>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import { VueCsvImport } from 'vue-csv-import';
import axiosAuth from '@/shared/configs/axios-auth'
import draggable from 'vuedraggable'
import MenuCard from './components/MenuCard.vue'
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  name: 'Speisekarten',
  mixins: [coreData],
  components: {
    draggable,
    MenuCard,
    VueJsonToCsv,
    VueCsvImport
  }, 
  data: () => {
    return {
      dropable: false,
      disableDragging: false,
      drag: true,
      file: null,
      imageData: "",
      copyMenu: null,
      copyExtras: null,
      copyVariants: null,
      menuItemBuffer: null,
      menuItemModal: false,
      extraBuffer: null,
      extraModal: false,
      extrasTemplateModal: false,
      extrasTemplateBuffer: null,
      variantsTemplateModal: false,
      variantsTemplateBuffer: null,
      newExtraModal: false,
      variantBuffer: null,
      variantModal: false,
      uploadsModal: false,
      newVariantModal: false,
      categoryBuffer: null,
      categoryModal: false,
      newCategoryModal: false,
      newMenuModal: false,
      menuSearch: '',
      currentPageCategories: 1,
      currentPageVariants: 1,
      currentPageExtras: 1,
      currentPageExtrasTemplates: 1,
      currentPageVariantsTemplates: 1,
      editModeMenu: false,
      editModeExtras: false,
      editModeCategories: false,
      editModeVariants: false,
      editModeExtrasTemplates: false,
      editModeVariantsTemplates: false,
      currentPage: 1,
      parseCsv: null,
      newMenu: {},
      newCategory: {},
      newVariant: {},
      newExtra: {},
      uploadComplete: false,
      newExtraTemplate: {
        extras: [],
        category: {}
      },
      newVariantTemplate: {
        variants: [],
        category: {}
      },
      menuCardSorted: [],
      newMenuVariant: {
        title: '',
        variants: []
      },
      fields: [
        { key: 'number', label: 'Nr.', sortable: true},
        { key: 'title', label: 'Name' },
        { key: 'category', label: 'Kategorie' },
        { key: 'description', label: 'Beschreibung' },
        { key: 'price', label: 'Preis' , sortable: true},
        { key: 'active', label: 'Aktiv' },
        // { key: 'delete', label: 'Löschen' },
      ],
      categoryFields: [
        { key: 'title', label: 'Name' },
        { key: 'description', label: 'Beschreibung' },
        { key: 'active', label: ' ' },
        { key: 'delete', label: 'Löschen' },
      ],
      extrasFields: [
        { key: 'title', label: 'Name' },
        { key: 'description', label: 'Beschreibung' },
        { key: 'category', label: 'Kategorie' },
        { key: 'price', label: 'Preis' },
        // { key: 'delete', label: 'Löschen' },
      ],
      extrasTemplatesFields: [
        { key: 'title', label: 'Name' },
        { key: 'category', label: 'Kategorie' },
        { key: 'description', label: 'Beschreibung' },
        // { key: 'delete', label: 'Löschen' },
      ],
      variantsTemplatesFields: [
        { key: 'title', label: 'Name' },
        { key: 'category', label: 'Kategorie' },
        { key: 'description', label: 'Beschreibung' },
        // { key: 'delete', label: 'Löschen' },
      ],
      variantsFields: [
        { key: 'title', label: 'Name' },
        { key: 'description', label: 'Beschreibung' },
        { key: 'category', label: 'Kategorie', sortable: true },
        { key: 'price', label: 'Aufpreis' },
        { key: 'extra_price', label: 'Aufpreis f. Extras', sortable: true },
        // { key: 'delete', label: 'Löschen' },
      ],
      daysOptions: [
        { text: 'Montag', value: {monday: true} },
        { text: 'Dienstag', value: {tuesday: true} },
        { text: 'Mittwoch', value: {wednesday: true} },
        { text: 'Donnerstag',value: {thursday: true} },
        { text: 'Freitag', value: {friday: true} },
        { text: 'Samstag', value: {saturday: true} },
        { text: 'Sunday', value: {sunday: true} },
      ],
      departmentForm: {},
      newDepartment: false
    }
  },

  watch:{
    menuItemModal(){
      if(!this.menuItemModal){
        this.file = null
        this.imageData = ""
        // this.editModeMenu = false
        this.copyExtras = null
      }
    },
    extraModal(){
      if(!this.extraModal){
        // this.editModeExtras = false
      }
    },
    variantModal(){
      if(!this.variantModal){
        // this.editModeVariants = false
      }
    },
    categoryModal(){
      if(!this.categoryModal){
        // this.editModeCategories = false
      }
    },
    menus(){
      if(this.menus && this.categories){
        this.menuCardSorted = JSON.parse(JSON.stringify(this.menuCardPreSorted))
      }
    }
  },

  computed: {
    menuCSV(){
      var menuCSV = []
      if(this.menus){
        this.menus.forEach(menu => {
          menuCSV.push({number: menu.number ? menu.number : '', title: menu.title, description: menu.description ? menu.description : '', price: menu.price.toFixed(2) + '€', category: menu.category.title, sortnumber: menu.category.sort_number})
        })
        menuCSV.sort(function(a, b) {
            var nameA = a.sortnumber;
            var nameB = b.sortnumber;
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            return 0;
          });
        }
        
      return menuCSV
    },
    dragOptions() {
      // var vm = this
      return {
        group: {
          name: "categories",
          put() {
            return true
          }
        },
      }
      },
    menuCardPreSorted(){
      let array = []

      if(this.categories){
        this.categories.forEach(category => {
          let menuitems = []
          if(this.menus){
            this.menus.forEach(menuitem => {
              if(menuitem.category._id == category._id){
                menuitems.push(menuitem)
              }
            })
          }
          array.push({category: category, menuitems: menuitems})
        })
      }

      return array
    },
    week(){
      if(this.kw){
        return {year: this.kw[0], week: this.kw[1], month: this.kw[2]}
      }
      return null
    },
    menuItemsOptions(){
      var array = []
      if(this.categories && this.menus){

        this.categories.forEach(category => {

          var group = {
            label: category.title, 
            options: []
          }

          if(this.menus.length > 0){
            this.menus.filter(menu => menu.category._id == category._id && menu.category).forEach(element => {
              group.options.push({value: element, text: element.title, data: element})
            });

            array.push(group)
          }
          

        })

        if(this.menus.filter(menu => !menu.category)){
          var group2 = {
            label: 'Ohne Kategorie', 
            options: []
          }

          this.menus.filter(menu => !menu.category).forEach(element => {
            group2.options.push({value: element, text: element.title, data: element})
          });

          array.push(group2)
        }
        
      }
      return array
    }
  },

  mounted(){
    this.refreshData();
  },

  methods: {
    handleDragging(value){
      console.log(value)
      this.disableDragging = value
    },
    onMove({ relatedContext, draggedContext }) {
      console.log(draggedContext)
      if(!relatedContext.element.category){
        this.disableDragging = true
      }else{
        this.disableDragging = false
      }
      console.log(relatedContext)
    },
    log(value){
      console.log(value)
      for (let index = 0; index < this.categories.length; index++) {
        this.menuCardSorted[index].category.sort_number = index;
      }
      this.menuCardSorted.forEach(menuCard => {
        this.updateCategory(menuCard.category)
      })
      // console.log(this.categories)
    },
    removeExtraTemplate(item){
      item.extraTemplate = null
      console.log(item)
    },
    deactivateEditModes(){
      this.updateCompanyDelayed()
      if(!this.company.active){
        this.editModeMenu = false
        this.editModeExtras = false
        this.editModeCategories = false
        this.editModeVariants = false
        this.editModeExtrasTemplates = false
        this.editModeVariantsTemplates = false
      }
    },
    setMediaImage(image){
      if(this.menuItemBuffer.img){
        this.menuItemBuffer.img.image = image
      }else{
        this.menuItemBuffer.img = {
          image: image,
          created: new Date(),
          type: "image/jpeg"
        }
      }
      
      console.log(image)
      this.uploadsModal = false
    },
    
    uploadImage(){
      this.$store.commit('updating', true)
      return new Promise((resolve, reject) => {

          if(!this.file){
            reject('Es wurde kein Logo hochgeladen!')
          }else{
            
            if(this.imageData){
              let formData = new FormData();

                formData.append('menu', this.menuItemBuffer._id)
                formData.append('image', this.file);

                axiosAuth.post('menus/upload/'+ this.menuItemBuffer._id, formData,)
                  .then(
                    () => {
                      resolve(true)
                      this.uploadComplete = true
                      this.$store.commit('updating', false)
                      this.$store.dispatch('getMedia')
                    }
                  )
                .catch(
                    error => {
                      this.$store.commit('updating', false)
                      console.log(error.response)
                      reject(error.response.data)
                    }
                ) 
            }else{
              this.$store.commit('updating', false)
              resolve(true)
            }
          }

      })
    },
    previewImage: function(event) {
        this.uploadComplete = false
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },

    copyMenuItem(){
      this.newMenu = JSON.parse(JSON.stringify(this.copyMenu))
      this.newMenu.title += ' (kopie)'
    },

    copyExtrasTemplate(value){
      console.log(value)
      if(this.menuItemBuffer){
        this.menuItemBuffer.extras = this.copyExtras.extras
        this.menuItemBuffer.extraTemplate = value
      }
      
      if(this.newMenuModal){
        this.newMenu.extras = this.copyExtras.extras
        this.newMenu.extraTemplate = value
      }

      this.copyExtras = null

    },

    copyVariantsTemplate(value){
      this.newMenuVariant.template = value._id
      this.newMenuVariant.variants = this.copyVariants.variants
      this.newMenuVariant.title = this.copyVariants.title
      if(this.newMenuModal){
        this.addVariant(this.newMenu)
      }else{
        this.addVariant(this.menuItemBuffer)
      }
      
    },

    openVariantTemplateModal(value){
      this.variantsTemplateBuffer = value
      this.variantsTemplateModal = true
    },


    openExtraTemplateModal(value){
      this.extrasTemplateBuffer = value
      this.extrasTemplateModal = true
    },
    
    openMenuItemModal(value){
      this.menuItemBuffer = value
      this.menuItemModal = true
    },

    openExtraModal(value){
      this.extraBuffer = value
      this.extraModal = true
    },

    openCategoryModal(value){
      this.categoryBuffer = value
      this.categoryModal = true
    },

    openVariantModal(value){
      this.variantBuffer = value
      this.variantModal = true
    },

    addVariant(menuitem){
      console.log(menuitem, this.newMenuVariant)
      if(menuitem.variants){
        menuitem.variants.push(JSON.parse(JSON.stringify(this.newMenuVariant)))
      }else{
        menuitem.variants = [JSON.parse(JSON.stringify(this.newMenuVariant))]
      }
      
      this.newMenuVariant = {
        template: null,
        title: '',
        variants: []
      }

      var payload = {
        _id: menuitem._id,
        data: menuitem
      }
      this.copyVariants = null
      if(this.newMenuModal) return
      this.$store.dispatch('updateMenu', payload)
      
    },

    updateMenuItems(){
      var payload = {}
      this.menus.forEach(element => {
        payload = {
          _id: element._id,
          data: element
        }
        this.$store.dispatch('updateMenu', payload)
      });
    },

    updateMenuItem(menuItem){
     
      var payload = {
        _id: menuItem._id,
        data: menuItem
      }

      this.$store.dispatch('updateMenu', payload)
    },

    updateCategory(category){
      var payload = {
        _id: category._id,
        data: category
      }
      this.$store.dispatch('updateCategory', payload)
    },

    updateCategories(){
      var payload = {}
        this.categories.forEach(element => {
          payload = {
            _id: element._id,
            data: element
          }
          this.$store.dispatch('updateCategory', payload)
        });

    },

    updateExtrasTemplate(extrasTemplate){
      var payload = {
        _id: extrasTemplate._id,
        data: extrasTemplate
      }
      this.$store.dispatch('updateExtrasTemplate', payload)
    },
    
    updateExtra(extra){
      var payload = {
        _id: extra._id,
        data: extra
      }
      this.$store.dispatch('updateExtra', payload)
    },

    updateExtras(){
      var payload = {}
        this.extras.forEach(element => {
          payload = {
            _id: element._id,
            data: element
          }
          this.$store.dispatch('updateExtra', payload)
        });

    },

    updateVariant(variant){
      var payload = {
        _id: variant._id,
        data: variant
      }
      this.$store.dispatch('updateVariant', payload)
    },

    updateVariantsTemplate(variantsTemplate){
      var payload = {
        _id: variantsTemplate._id,
        data: variantsTemplate
      }
      this.$store.dispatch('updateVariantsTemplate', payload)
    },

    updateVariants(){
      var payload = {}
        this.variants.forEach(element => {
          payload = {
            _id: element._id,
            data: element
          }
          this.$store.dispatch('updateVariant', payload)
        });

    },

    postExtraTemplate(){
      if(this.newExtraTemplate.extras.length == 0) return 
      this.$store.dispatch('postExtraTemplate', this.newExtraTemplate)
      this.newExtraTemplate = {
        extras: [],
        title: null,
        description: null,
        category: {}
      }
    },

    postVariantsTemplate(){
      if(this.newVariantTemplate.variants.length == 0) return 
      this.$store.dispatch('postVariantsTemplate', this.newVariantTemplate)
      this.newVariantTemplate = {
        variants: [],
        title: null,
        description: null,
        category: {}
      }
    },

    postMenu(){
      console.log('post menu')
      if(!this.newMenu.category) return
      this.$store.dispatch('postMenu', this.newMenu)
      this.makeToastMenu(false, this.newMenu.title)
      this.newMenu = {
        extras: [],
        additives: [],
        allergens: []
      }
      
    },
    postCategory(){
      this.$store.dispatch('postCategory', this.newCategory)
      this.newCategory = {}
      //this.newCategoryModal = false
    },
    postExtra(){
      this.$store.dispatch('postExtra', this.newExtra)
      this.newExtra = {}
      //this.newExtraModal = false
    },
    postVariant(){
      console.log('TEST')
      this.$store.dispatch('postVariant', this.newVariant)
      this.newVariant = {}
      //this.newVariantModal = false
      this.copyVariants = null
    },
    deleteMenu(id){
      this.$store.dispatch('deleteMenu', {_id: id})
    },
    deleteCategory(id){
      this.$store.dispatch('deleteCategory', {_id: id})
    },
    deleteExtra(id){
      this.$store.dispatch('deleteExtra', {_id: id})
    },
    deleteExtrasTemplate(id){
      this.$store.dispatch('deleteExtrasTemplate', {_id: id})
    },
    deleteVariantsTemplate(id){
      this.$store.dispatch('deleteVariantsTemplate', {_id: id})
    },
    deleteVariant(id){
      this.$store.dispatch('deleteVariant', {_id: id})
    },
    updateMenu(item){
      var payload = {
        _id: item._id,
        data: item
      }
      this.$store.dispatch('updateMenu', payload)
    },
    setMenuActive(item){
      item.active = !item.active
      var payload = {
        _id: item._id,
        data: {
          active: item.active
        }
      }
      this.$store.dispatch('updateMenu', payload)
    }
  }
}
</script>

<style lang="scss" scoped>

.ghost-card {
  opacity: 0.5;
  background: #F7FAFC;
}

</style>